import React, { useEffect } from 'react';
import { Box, Text, Flex, Image } from '@chakra-ui/react';
import { ThankYou } from '../../utils/Images';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetForm } from '../../store/formSlice';
import { useProfileImage } from "../../store/ProfileImageContext";
import { authlogin, clearAuthTempLogin } from '../../store/Authentication';

const ThankYouStep = React.memo(() => {
    const authTempData = useSelector((state) => state.Authlogin.dataTemp)
    const firstName = useSelector((state) => state.form.formData.firstName) || 'First Name';
    const { clearProfileImage } = useProfileImage();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate("/landing/home");
            dispatch(authlogin(authTempData));
            dispatch(clearAuthTempLogin());
            dispatch(resetForm())
            clearProfileImage()
        }, 5000); // 5 seconds

        return () => clearTimeout(timer); // Cleanup on unmount
    }, [navigate]);
    return (
        <Box maxW={{ base: '100%', md: '3xl' }} mx="auto" p={{ base: 4, md: 6 }} textAlign="center">
            <Flex direction="column" align="center" justify="center" mb={{ base: 4, md: 8 }}>
                <Image src={ThankYou} aspectRatio={4 / 3}
                    width="350px" height="174px" />
            </Flex>
            <Text fontSize={{ base: '16px', md: '22px' }} color="black" fontFamily="Nunito" maxW="lg" mx="auto">
                {`You're all set! The first step to brighter, more connected days for `}
                <Text as="span" color="brand.500" fontWeight="semibold" display="inline">
                    {firstName}
                </Text>
                {` has begun.`}
            </Text>
        </Box>
    );
});

export default ThankYouStep; 